import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { CITIES, PROPERTY_TYPES } from "@/lib/format";

const selectCls =
  "input-lux appearance-none bg-[url('data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%2212%22 height=%2212%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22%230A2A1A%22 stroke-width=%222%22%3E%3Cpath d=%22m6 9 6 6 6-6%22/%3E%3C/svg%3E')] bg-no-repeat bg-[position:left_0.9rem_center] ps-4 pe-4";

export default function SearchBar({ compact = false }) {
  const navigate = useNavigate();
  const [city, setCity] = useState("");
  const [purpose, setPurpose] = useState("");
  const [ptype, setPtype] = useState("");

  const submit = (e) => {
    e.preventDefault();
    const params = new URLSearchParams();
    if (city) params.set("city", city);
    if (purpose) params.set("purpose", purpose);
    if (ptype) params.set("ptype", ptype);
    navigate(`/properties?${params.toString()}`);
  };

  return (
    <form
      onSubmit={submit}
      className={`glass rounded-2xl p-4 md:p-5 flex flex-col md:flex-row gap-3 ${compact ? "" : "shadow-[0_20px_60px_rgba(10,42,26,0.15)]"}`}
      data-testid="property-search-form"
    >
      <select value={city} onChange={(e) => setCity(e.target.value)} className={selectCls} aria-label="المدينة" data-testid="search-city-select">
        <option value="">كل المدن</option>
        {CITIES.map((c) => (
          <option key={c} value={c}>{c}</option>
        ))}
      </select>
      <select value={purpose} onChange={(e) => setPurpose(e.target.value)} className={selectCls} aria-label="الغرض" data-testid="search-purpose-select">
        <option value="">بيع أو إيجار</option>
        <option value="sale">للبيع</option>
        <option value="rent">للإيجار</option>
      </select>
      <select value={ptype} onChange={(e) => setPtype(e.target.value)} className={selectCls} aria-label="نوع العقار" data-testid="search-type-select">
        <option value="">كل الأنواع</option>
        {PROPERTY_TYPES.map((t) => (
          <option key={t} value={t}>{t}</option>
        ))}
      </select>
      <button type="submit" className="btn-gold md:min-w-36" data-testid="search-submit-button">
        <Search className="h-4 w-4" aria-hidden="true" />
        ابحث
      </button>
    </form>
  );
}
